import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';

import { Card, InputAdornment, makeStyles, Paper, Typography, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search'
import { Autocomplete } from '@material-ui/lab';
import { TextValidator } from 'react-material-ui-form-validator';
import { getValidations } from '../../../helpers/validations/getValidations';
import { fetchConToken } from '../../../helpers/fetch';
import { InputField } from '../atoms/Inputs';

const useStyles = makeStyles({
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        flex: 1
    },
    iconButton: {
        padding: 10,
    },
    card: {
        padding: "1rem"
    }
});

export const Buscador = forwardRef(({ 
  label, fieldsDisabled, value,
  setValue, endpoint, noOptionText,
  getOptionLabel, variant = "outlined", renderOption,
  filterOptions, validations = false, margin, getOptionSelected = () => {}, textProps = {}, ...props
}, ref) => {
    const { validators, errorMessages } = validations ? getValidations(validations) : [];
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(false);
    const [options, setOptions] = useState([]);

    useImperativeHandle(ref, () => ({
        resetValues: () => {
        setOptions([]);
        }
    }));

    useEffect(() => {
        let active = true;

        setLoading(true);

        if (inputValue === '') {
        setOptions(value ? [value] : []);
        setLoading(false);
        return undefined;
        }

        if(search){
        (async () => {
            const response = await fetchConToken(endpoint(inputValue));
            const contentType = response.headers.get("content-type");
            if (response.ok && contentType && contentType.indexOf("application/json") !== -1) {
            let results = await response.json();
            if(filterOptions){
                results = filterOptions(results);
            }
            if (active) {
                let newOptions = [];
        
                if (value) {
                newOptions = [value];
                }
        
                newOptions = [...newOptions, ...results];
        
                setOptions(newOptions);
                setLoading(false);
            }
            }
        })();
        }
        return () => {
        active = false;
        };
    }, [value, inputValue, search]);

    return (
        <Autocomplete
            id="asynchronous-demo"
            disabled={fieldsDisabled}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption || getOptionLabel}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            fullWidth
            includeInputInList
            filterSelectedOptions
            getOptionSelected={getOptionSelected}
            value={value}
            onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setSearch(false); 
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
                setSearch(true); 
            }}
            noOptionsText={noOptionText}
            loadingText="Buscando..."
            loading={loading}
            {...props}
            renderInput={(params) => {
                const marginProp = margin ? {margin: "normal"} : {}
                if(!validations){
                return <TextField {...params} {...marginProp} label={label} {...textProps}  variant={variant} fullWidth />
                }else{
                return <TextValidator {...params} {...marginProp} value={value !== null ? inputValue : ""} {...textProps} label={label} variant={variant} fullWidth validators={validators} errorMessages={errorMessages} />
                }
            }}
        />
    )
});


export const BuscadorFilter = forwardRef(({ title, setTexto, texto, placeholder = 'Nombre', variant = "standard", titleStyle = {}, type = "number" }, ref) => {
    const classes = useStyles();

    const handleChange = (e) => {
        setTexto(e.target.value);
    };

    return (
        <Card>
            <Typography style={titleStyle}>
                <strong>{title}</strong>
            </Typography>
            <Paper className={classes.paper}>
                <InputField
                    className={classes.input}
                    placeholder={placeholder}
                    onChange={handleChange}
                    type={type}
                    value={texto}
                    variant={variant}
                    endAdornment={(
                        <InputAdornment position="end">
                            <SearchIcon style={{color: "#999"}} />
                        </InputAdornment>
                    )}
                />
            </Paper>
        </Card>
    );
});